import React from "react";
import "./App.css";
import Restaurant from "./Components/Restaurant";
import Footer from "./Components/Footer";

function App() {
  return (
    <React.StrictMode>
      <Restaurant />
      <Footer />
    </React.StrictMode>
  );
}
export default App;
